/* eslint-disable react/prop-types */
import React from 'react';
import ViewReminder from '../viewReminder/viewReminder';

export default function ReminderReview({ setStage, reminders }) {
  return(
    <>
      <span>Confirma os teus lembretes</span>
      <p>Verifica se está tudo certo antes de activar.</p>
      <div className="reminder-scroll">
        {reminders?.map((reminder, index) => (
          <ViewReminder key={index} reminder={reminder} />
        ))}
      </div>
      <div id="buttons">
        <button onClick={() => setStage('SUCCESS')} className="reminder-button-active">Confirmar e activar lembretes</button>
        <button onClick={() => setStage('FORM')} className="reminder-button-inactive">Voltar e editar</button>
      </div>
    </>
  );
}